'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.stringify = stringify;
exports.parse = parse;
exports.ensureNonCyclic = ensureNonCyclic;

var _jsonCycle = require('json-cycle');

var _jsonCycle2 = _interopRequireDefault(_jsonCycle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringify(object) {
    return (0, _stringify2.default)(_jsonCycle2.default.decycle(object));
}

function parse(string) {
    return _jsonCycle2.default.retrocycle(JSON.parse(string));
}

function ensureNonCyclic(stringOrObject) {
    if (typeof stringOrObject === 'string') {
        return stringify(parse(stringOrObject));
    }
    return stringify(stringOrObject);
}

exports.default = {
    stringify: stringify,
    parse: parse,
    ensureNonCyclic: ensureNonCyclic
};